import {
  PolicyGroupCreateRequest,
  PolicyGroupDeleteResponse,
  PolicyGroupListResponse,
  PolicyGroupResponse,
  PolicyGroupUpdateRequest,
} from '@/types/service/policyGroup';

import { baseProtectedApi } from '@/store/baseApi';

export const policyGroupApi = baseProtectedApi.injectEndpoints({
  endpoints: (builder) => ({
    createPolicyGroup: builder.mutation<PolicyGroupResponse, PolicyGroupCreateRequest>({
      query: (data) => ({
        url: '/v1/protected/policy-groups',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['PolicyGroupList'],
    }),
    getPolicyGroups: builder.query<PolicyGroupListResponse, void>({
      query: () => ({
        url: '/v1/protected/policy-groups',
        method: 'GET',
      }),
      providesTags: ['PolicyGroupList'],
    }),
    getPolicyGroup: builder.query<PolicyGroupResponse, number>({
      query: (groupId) => ({
        url: `/v1/protected/policy-groups/${groupId}`,
        method: 'GET',
      }),
      providesTags: ['PolicyGroup'],
    }),
    updatePolicyGroup: builder.mutation<
      PolicyGroupResponse,
      { groupId: number; data: PolicyGroupUpdateRequest }
    >({
      query: ({ groupId, data }) => ({
        url: `/v1/protected/policy-groups/${groupId}`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: ['PolicyGroup', 'PolicyGroupList'],
    }),
    deletePolicyGroup: builder.mutation<PolicyGroupDeleteResponse, number>({
      query: (groupId) => ({
        url: `/v1/protected/policy-groups/${groupId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PolicyGroup', 'PolicyGroupList'],
    }),
  }),
});

export const {
  useCreatePolicyGroupMutation,
  useGetPolicyGroupsQuery,
  useGetPolicyGroupQuery,
  useUpdatePolicyGroupMutation,
  useDeletePolicyGroupMutation,
} = policyGroupApi;
